const getters = {
  user: state => state.user,
  getKeepAlivePage: state => {
    return state.keepAlive.keepAlivePage;
  }
};
export default getters;
